import { Component } from '@angular/core';

@Component({
  selector: 'app-avatar-showcase',
  templateUrl: './avatar-showcase.component.html',
  styleUrls: ['./avatar-showcase.component.scss']
})
export class AvatarShowcaseComponent {
  sampleImageUrl = 'https://ui-avatars.com/api/?name=John+Doe&background=00bfff&color=fff';
}
